import { Button } from '@modusign/design-system';
import { forwardRef, MouseEvent, ReactNode } from 'react';

interface BulkRequestStartPageButtonProps {
  children: ReactNode;
  disabled?: boolean;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
}

const BulkRequestStartPageButton = forwardRef<HTMLButtonElement, BulkRequestStartPageButtonProps>(
  function BulkRequestStartPageButton({
    children,
    disabled,
    onClick,
  }: BulkRequestStartPageButtonProps) {
    return (
      <Button
        color="textNeutralSlightlyLight"
        disabled={disabled}
        height="48px"
        mx="0"
        my={2}
        paddingLeft="6px"
        paddingRight="6px"
        sx={{ width: '100%' }}
        onClick={onClick}
      >
        {children}
      </Button>
    );
  }
);

export default BulkRequestStartPageButton;
